import ApiService from "@/services/api.services";
import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import AdminRoutes from "./admin/admin.routes";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  linkActiveClass: "active",
  routes: [...AdminRoutes]
});

router.beforeEach((to, from, next) => {
  const isPublic = to.matched.some(record => record.meta.public);
  const prefix = store.state.auth.prefixRoute;
  const prefixStorage = localStorage.getItem("prefixRoute");
  const prefixTo = to.params.prefix;
  const finalPrefix = prefix || prefixStorage || prefixTo;

  if (!isPublic && !store.state.auth.accessToken) {
    return next({ name: "login", params: { prefix: finalPrefix } });
  } else if (
    store.state.auth.accessToken &&
    (to.name === "login" || to.name === "login-prefix")
  ) {
    return next({ name: "home", params: { prefix: finalPrefix } });
  }
  ApiService.setHeader();

  return next({ params: { prefix: finalPrefix } });
});

export default router;
